export default {
    orders: {
        actionUndo: {
            message: "Pokud jste klikli omylem, kliknutím na odkaz níže se vrátíte zpět.",
            undo: "Kliknutím vrátíte zpět"
        }
    }
}